import axios from "axios";
import helpers from "@/helpers.js";
import store from '../../store'
// import firebase from "firebase";

class Reporters {

    constructor() {

        if(store.state.companies.currentCompany.id){
            this.company_id = store.state.companies.currentCompany.id ;
        } 

    }

    set_company_id(company_id){
        this.company_id = company_id ;
    }

    get() {

        let params = "" ;

        params = params + "&company_id="+this.company_id ;
        
        store.commit("app/SET_LOADER", true) ;

        return helpers.get_token().then(function(idToken) {
            
            // console.log('GET FIRE');

            const config = {
                headers: { Authorization: "Bearer " + idToken }
            };
            
            return axios.get( 
                helpers.get_api_endpoint("/reporters", params),
                config
            ).then(function(response) {

                store.commit("reporters/set_reporters", response.data) ;
                store.commit("app/SET_LOADER", false) ;

                return response.data ; 

            })
            .catch(error => {
                store.commit("app/SET_ERROR", error) ;
                return error ; 
            });

        }).catch(function(error) {
            store.commit("app/SET_ERROR", error) ;  
            return error ; 
        });
        
    }

}

export default Reporters ;
